import React from "react";
import Gate from "../../Gate";

const Screen26 = () => {
    return <Gate />;
};

export default Screen26;
